<template>
  <div class="com-box">
    <van-field
      label="赠送求签机会"
      input-align="right"
    >
      <template #input>
        <van-radio-group v-model="form.everyDaySendType" direction="horizontal" icon-size="16px" checked-color="#FF6B31">
          <van-radio name="everyDay">每日赠送</van-radio>
          <van-radio name="once">一次性赠送</van-radio>
        </van-radio-group>
      </template>
    </van-field>
    <van-field
      v-model="form.everyDaySendCount"
      type="digit"
      :maxlength="4"
      :label="label"
      input-align="right"
      placeholder="请输入"
      @blur="checkFeeValid('everyDaySendCount')"
    >
      <span slot="right-icon">次求签机会</span>
    </van-field>
    <div class="field-item border-bottom">
      <div class="field-item-title bold">
        顾客拉新
        <van-radio-group v-model="form.boolNewPeopleSendCount" direction="horizontal" icon-size="16px" checked-color="#FF6B31">
          <van-radio :name="false">关闭</van-radio>
          <van-radio :name="true">开启</van-radio>
        </van-radio-group>
      </div>
      <div class="tips switch-tips">完成顾客拉新任务获得额外求签机会</div>
    </div>
    <template v-if="form.boolNewPeopleSendCount">
      <div class="other">
        <van-field
          v-model="form.everyTimeNewPeopleNumber"
          type="digit"
          :maxlength="4"
          label="邀请新客查看活动,每拉新"
          label-width="12em"
          input-align="center"
          placeholder="请输入"
          @blur="checkFeeValid('everyTimeNewPeopleNumber')"
        >
          <span slot="right-icon">人可获得</span>
        </van-field>
      </div>
      <div class="list">
        <div class="list-other">
          <van-field
            v-model="form.newPeopleSendCount"
            type="digit"
            :maxlength="4"
            input-align="center"
            placeholder="请输入"
            class="other"
            @blur="checkFeeValid('newPeopleSendCount')"
          >
            <span slot="right-icon">次机会,最多送</span>
          </van-field>
        </div>
        <div class="list-other1">
          <van-field
            v-model="form.newPeopleSendTotalCount"
            type="digit"
            :maxlength="4"
            input-align="center"
            placeholder="请输入"
            @blur="checkFeeValid('newPeopleSendTotalCount')"
          >
            <span slot="right-icon">次求签机会</span>
          </van-field>
        </div>
      </div>
      <span class="tips">
        <van-icon name="warning-o" />
        第三个空必须是第二个空的倍数
      </span>
    </template>

    <template>
      <div class="field-item border-bottom">
        <div class="field-item-title bold">
          报名
          <van-radio-group v-model="form.boolSignUpSendCount" direction="horizontal" icon-size="16px" checked-color="#FF6B31">
            <van-radio :name="false">关闭</van-radio>
            <van-radio :name="true">开启</van-radio>
          </van-radio-group>
        </div>
        <span class="tips switch-tips">完成报名任务获得额外求签机会</span>
        <!-- <van-switch
          v-model="form.boolSignUpSendCount"
          size="24px"
          active-color="#FF6B31"
          inactive-color="#f4f4f4"
        /> -->
      </div>
      <van-field
        v-if="form.boolSignUpSendCount"
        v-model="form.signUpSendCount"
        type="digit"
        :maxlength="4"
        label="顾客成功报名活动,可获得"
        label-width="12em"
        input-align="center"
        placeholder="请输入"
        @blur="checkFeeValid('signUpSendCount')"
      >
        <span slot="right-icon">次求签机会</span>
      </van-field>
    </template>
    <div class="field-item border-bottom">
      <div class="field-item-title bold">
        屏蔽内部职员
        <van-radio-group v-model="form.boolInternalStaffLimit" direction="horizontal" icon-size="16px" checked-color="#FF6B31">
          <van-radio :name="false">关闭</van-radio>
          <van-radio :name="true">开启</van-radio>
        </van-radio-group>
      </div>
      <span class="tips switch-tips">开启后内部职员将无法中签</span>
    </div>
    <div class="field-item border-bottom">
      <div class="field-item-title bold">
        地理位置限制
        <van-radio-group v-model="form.boolAreaLimited" direction="horizontal" icon-size="16px" checked-color="#FF6B31">
          <van-radio :name="false">关闭</van-radio>
          <van-radio :name="true">开启</van-radio>
        </van-radio-group>
      </div>
      <span class="tips switch-tips">(开启后非分享人门店同市将无法中签)</span>
    </div>
  </div>
</template>

<script>
import { round2Places } from "@/utils/utils"
export default {
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: {
      type: Object,
      default() {
        return {};
      },
    },
    isHasSignUp: {
      type: Boolean,
      default: false,
    },
    isHasreserve: {
      type: Boolean,
      default: false,
    },
    basicInfoForm: {
      type: Object,
      default() {
        return {};
      },
    },
    from: {
      type: String,
      default: "",
    },
  },
  computed: {
    form: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit("change", newVal);
      },
    },
    label() {
      return this.form.everyDaySendType == 'everyDay' ? '每人每日赠送' : '本场活动赠送'
    },
  },
  data() {
    return {};
  },
  methods: {
    checkFeeValid(fied) {
      let fieldValue = this.form[fied];
      this.form[fied] = round2Places(fieldValue);
      if (this.form.boolNewPeopleSendCount) {
        let map = ['everyTimeNewPeopleNumber','newPeopleSendCount','newPeopleSendTotalCount']
        this.form[fied] = this.form[fied] == 0 ? 1 : round2Places(fieldValue);
        const {everyTimeNewPeopleNumber,newPeopleSendCount,newPeopleSendTotalCount} = this.form
        if (map.includes(fied)) {
          this.form.newPeopleSendMaxCount = ''
          if (!everyTimeNewPeopleNumber || !newPeopleSendCount || !newPeopleSendTotalCount) {
            this.$toast("请完善求签机会设置");
          }else if (newPeopleSendTotalCount < newPeopleSendCount || (newPeopleSendTotalCount % newPeopleSendCount) !== 0) {
              this.$toast({
                message: '《顾客拉新》中第三个空必须是第二个空的倍数',
                duration: 3000
              })
          }else {
            this.form.newPeopleSendMaxCount = newPeopleSendTotalCount / newPeopleSendCount
          }
        }
      }
    },
    checkValid() {
      this.form.newPeopleSendMaxCount = this.form.newPeopleSendTotalCount / this.form.newPeopleSendCount
      const {
        boolNewPeopleSendCount,
        boolSignUpSendCount,
        boolLiveReserveSendCount,
        everyTimeNewPeopleNumber,
        newPeopleSendCount,
        newPeopleSendMaxCount,
        signUpSendCount,
        liveReserveSendCount,
        newPeopleSendTotalCount
      } = this.form
    
      if (boolNewPeopleSendCount && (!everyTimeNewPeopleNumber || !newPeopleSendCount)) {
        this.$toast("请完善求签机会设置");
        return false
      } else if (boolNewPeopleSendCount && (newPeopleSendTotalCount % newPeopleSendCount) !== 0) {
        this.$toast({
          message: '《顾客拉新》中第三个空必须是第二个空的倍数',
          duration: 3000
        })
        return false
      } else if (boolSignUpSendCount && !signUpSendCount) {
        this.$toast("请完善求签机会设置");
        return false
      } else if (boolLiveReserveSendCount && !liveReserveSendCount) {
        this.$toast("请完善求签机会设置");
        return false
      }
      return true;
    },
  },
};
</script>

<style lang="stylus" scoped>
.com-box
  margin 15px;
  margin-top: 6px;
  background: #fff;
  >>> .van-collapse
    border-radius: 8px 8px 0 0
    overflow hidden
  .collapse-item
    >>> .van-collapse-item__title .van-cell__title
      font-weight 600
    >>> .van-collapse-item__content
      padding 0
      .van-cell__title
        color #909399
	>>> .van-field__body input
		color $mainTextColor

.field-item
  // display: flex
  // justify-content: space-between
  // align-items: center
  padding 10px 16px
  font-size 14px
  background-color: #fff
  &-title
    display: flex
    justify-content: space-between
    align-items: center
    color #323233
    font-weight 600
    
		background: pink;
	.tips {
		color: #999;
		font-size: 10px;
		margin-left: 18px;
    padding-top: 10px;

	}
  .switch-tips {
    margin-left: 0;
    color: red;
  }
	.list {
		display: flex;
		align-items: center
		>>> .van-cell {
			padding: 2px 16px 10px 16px;
		}
    .list-other {
      >>> .van-cell {
        padding-left: 10px;
        padding-right: 0;
        .van-field__body input {
          border-bottom: 1px solid #909399;
        }
      }
    }
    .list-other1 {
       >>> .van-cell {
        padding-left: 8px;
        .van-field__body input {
          border-bottom: 1px solid #909399;
        }
      }
    }
	}
  .other {
    >>> .van-cell {
      .van-field__body input {
        border-bottom: 1px solid #909399;
      }
    }
  }
	.collapse-title {
		font-size: 14px;
		margin-left: 14px;
		color: #000;
		padding-top: 2px;
	}
  .border-bottom{
    background: #fff;
    border-bottom: 1px solid #f4f4f4;
  }
.comContentMargin {
  margin: 15px;
}
</style>
